export default __webpack_public_path__ + "static/media/clinic6.f15d243a.jpg";